import { combineReducers } from "redux";

// Import Components
import { sideMenuReducer } from "./sideMenuReducer";

export const rootReducer = combineReducers({
  sideMenu: sideMenuReducer,
});
